import { createRoot } from 'react-dom/client';
import { AdminApp } from '@eir/admin';
import './config/global';
import partnerLogo from './images/partner_logo.svg';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<AdminApp logo={partnerLogo} />);
